module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/decorations/deco-dots-3-64b37f0d8aa47c38b13b94ed304307b3.svg";